import { Button, ButtonGroup } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	font-size: clamp(1px, 2.8dvw, 12px);
	margin-top: 5px;

	@media (min-width: 720px) {
		font-size: clamp(1px, 1.4dvw, 12px);
	}
`;

export const StyledButtonGroup = styled(ButtonGroup)`
	border-radius: 20px;
	padding: 0.42em;
	background-color: #479fba;
	& .MuiButtonGroup-grouped {
		background-color: #479fba;
		border-radius: 20px;
		min-width: 2.5em;
	}
	& .MuiButtonGroup-grouped:not(:last-of-type) {
		border-right: 0em;
	}
`;

export const CustomButton = styled(Button)`
	font-size: 1em;
	height: 2.4em;
	text-transform: capitalize;
	padding: 0.67em;
	text-align: left;

	&.expanded {
		background-color: white;
		color: #479fba;
		border-radius: 2.08em !important;
	}

	@media (min-width: 720px) {
		border-radius: 2.08em !important;
		margin: 0em 0.17em;
		border: 0.08em solid rgba(255, 255, 255, 0.3) !important;
	}
`;

export const ExpandedText = styled.span`
	width: 0;
	overflow: hidden;
	transition: width 0.3s ease-in-out;
	white-space: nowrap;
	margin-left: 0.17em;
	font-family: Inter;
	font-style: normal;
	font-weight: 700;

	&.expanded {
		width: 8.33em;
		padding: 0.42em;
	}

	@media (min-width: 720px) {
		width: fit-content;
		padding: 0.42em;

		&.expanded {
			width: fit-content;
		}
	}
`;

export const Dot = styled.div`
	position: absolute;
	top: -0.08em;
	right: 0.25em;
	width: 1.08em;
	height: 1.08em;
	border-radius: 100%;
	background-color: #e53939;
`;
